module.exports = __webpack_public_path__ + "dfec1d2ab8104edbe7b453a351de7978.jpg";